import { PermissionLevels, Permissions, ViewPermissions } from '../types/AccessControls'

export const checkUserHasPermission = (
  requiredPermission: Permissions,
  userAllowedPermission?: Permissions[],
) => {
  if (!userAllowedPermission) return false
  const permissionIndex = userAllowedPermission.findIndex(
    permissionItem => permissionItem === requiredPermission,
  )
  const userHasRequiredPermission = permissionIndex >= 0
  return userHasRequiredPermission
}

export const checkUserHasViewPermission = (
  permissionLevel?: PermissionLevels,
  viewPermissions?: ViewPermissions,
) => {
  if (!permissionLevel || !viewPermissions) return false
  // The backend returns resource keys lowercased (e.g. "nsdcexam"), while some
  // PermissionLevels enum values are camelCase (e.g. "nsdcExam"). Match case-insensitively
  // so those levels aren't treated as denied.
  const matchedEntry = Object.entries(viewPermissions).find(
    ([key]) => key.toLowerCase() === permissionLevel.toLowerCase(),
  )
  return matchedEntry?.[1] ?? false
}
